import { createFileRoute } from '@tanstack/react-router';
import { FloorplanSettings } from '@/features/storage/FloorplanSettings';

export const Route = createFileRoute('/_shell/storage/floorplan-settings/new')({
  component: () => <FloorplanSettings floorplanId={null} />,
});
